import { render } from "./PriceSummary.vue?vue&type=template&id=13fe17d2&scoped=true&lang=pug"
import script from "./PriceSummary.vue?vue&type=script&lang=ts"
export * from "./PriceSummary.vue?vue&type=script&lang=ts"

import "./PriceSummary.vue?vue&type=style&index=0&id=13fe17d2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13fe17d2"

export default script